import {
  computeMilestoneDates,
  mapPercentCompleteToEncouragementType,
  MILESTONE_PERCENTAGE,
} from 'Components/ProductProgressCard/utils';

export const mapProductProgressesToProductProgressCards = (
  productProgresses,
  studentSemester,
  imageUrl,
  prefixImageUrl
) => {
  try {
    return productProgresses
      .filter((productProgress) => !!productProgress.product.product)
      .map((productProgress) => {
        try {
          const milestones = computeMilestoneDates({
            caps: {
              weekdayHours: studentSemester.weekdayCapWorkload,
              weekendHours: studentSemester.weekendCapWorkload,
            },
            totalHours: productProgress.progress.totalDuration / 60 / 60,
            milestones: [MILESTONE_PERCENTAGE.THIRTY, MILESTONE_PERCENTAGE.EIGHTY],
            start: studentSemester.startDate,
            end: studentSemester.endDate,
            tz: 'Asia/Bangkok',
          });
          const { isMigrated, isSplitted } = productProgress.product.metadata;
          return {
            id: productProgress.product.id,
            name: productProgress.product?.product?.name ?? '',
            subjectName: productProgress.product?.subject?.name ?? '',
            totalDuration: productProgress.progress.totalDuration,
            percentComplete: productProgress.progress.percentComplete,
            productType: productProgress.product?.product?.type ?? '',
            thumbnailUrl:
              prefixImageUrl &&
              productProgress.product?.product?.academicYear &&
              productProgress.product?.product?.name
                ? `${imageUrl}/${prefixImageUrl}/${productProgress.product.product.name}_${productProgress.product.product.academicYear}.png`
                : `${imageUrl}/${prefixImageUrl}/${productProgress.product.product.name}.png`,
            hasProduct: productProgress.hasProduct,
            milestones,
            encouragementType: mapPercentCompleteToEncouragementType({
              milestones,
              percentComplete: productProgress.progress.percentComplete,
            }),
            isMigrated: isMigrated ?? false,
            isSplitted: isSplitted ?? false,
          };
        } catch (error) {
          console.error('Failed to compute milestones', error);
          return false;
        }
      })
      .filter((productProgressCard) => productProgressCard !== false);
  } catch (error) {
    console.error('Error mapping product progresses to product progress cards:', error);
    return [];
  }
};
